module.exports = __webpack_public_path__ + "static/media/17-M-Cure 9.7994715d.jpg";